module.exports = __webpack_public_path__ + "img/Registeration.1ac20ac2.png";